import { SupportedBrowser } from './SupportedBrowser/SupportedBrowser';
import { UnsupportedBrowser } from './UnsupportedBrowser/UnsupportedBrowser';
import {useAppStateContext} from "../../AppStateProvider/AppStateProvider";

export function BrowserTest() {
  const { userAgentInfo } = useAppStateContext();
  const browser = userAgentInfo.browser;
  return <>{browser.name === "Chrome" ? <SupportedBrowser /> : <UnsupportedBrowser />}</>;
}
